'use client';

import React from 'react';
import {
  ImagesModalSectionProps,
  MediaModalSectionName,
} from '@/features/media-modal/components/common/commonTypes';
import { IntegrationAssetModalContent } from './sections-content/IntegrationAssetModalContent';

const sectionTitles = {
  [MediaModalSectionName.instagram]: 'Instagram',
  [MediaModalSectionName.tiktok]: 'TikTok',
  [MediaModalSectionName.playApp]: 'Tolstoy',
};

export const IntegrationMediaModalSection = (
  props: ImagesModalSectionProps
) => {
  const { section } = props;

  return (
    <IntegrationAssetModalContent title={sectionTitles[section]} {...props} />
  );
};
